<template>
    <div>
        <div
            class="row no-gutters"
            style="background-image: url('/images/WCPG_Building.png'); height: 30vh; position: relative; background-position: center center;"
        >
            <h1
                class="ml-3 text-light"
                style="position: absolute; bottom: 2rem; left: 2rem;"
            >
                Product Catalogs
            </h1>
        </div>
        <div class="row no-gutters p-5">
            <div class="col-md-12">
                <!-- <h2
                    class="text-uppercase text-primary text-center border-bottom pb-4"
                >
                    product catalogs
                </h2> -->
                <div
                    id="literature-container"
                    class="d-flex flex-wrap align-items-stretch"
                >
                    <div
                        class="literature d-flex flex-column align-items-center"
                        v-for="literature in literatures"
                        :key="'lit' + literature.id"
                    >
                        <router-link  :to=" '/docs/Literature/' + literature.path "  target="_blank" >
                            <img :src=" '/images/catalogs/' + literature.image_path "  alt="" class="mb-3"  />
                        </router-link>
                        <router-link  :to=" '/docs/Literature/' + literature.path "  target="_blank" class="btn btn-primary w-100" >DOWNLOAD</router-link >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    data() {
        return {
            literatures: null,
        };
    },
    created() {
        axios.get(`/api/literatures`).then(response => {
            this.literatures = _.orderBy(response.data,"id");
        });


    }
};
</script>

<style scoped lang="scss">
.literature {
    max-width: 300px;
    margin: 1em;
    transition: all 0.4s ease-out;
    img {
        max-width: 100%;
    }
}
</style>
